
import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import firebaseApp from './firebase';

import { getUserToken, removeUser, setUser, listenToConnected, setAppField, setTitle, gettingToken, saveNotificationToken, setModal, removeToast, insertToast, fetchTherapyCategories, fetchPractices,fetchPracticeTypes } from "./actions";
//import {Layout} from 'react-mdl';

import Header from './components/header/Header';
import Sidenav from './components/sidenav/Sidenav';
import AppNav from './components/sidenav/content/AppNav'
import MenuBar from './components/sidenav/MenuBar'
import MediaUploadContent from './components/therapist/MediaUpload'
import Modal from './components/ui/Modal';
import Toast from './components/ui/Toast';
import ReactGA from 'react-ga';

//import logo from './logo.svg';
import './styles/App.scss';
import SVGBlur from './components/ui/images/SVGBlur'
let NODE_ENV = process.env.NODE_ENV;
const BUILDING = process.env.BUILDING

// import * as Sentry from '@sentry/browser';

// Sentry.init({
// 	dsn: "https://94447e374cf54aefb9e46d047016e41e@sentry.hellofirstview.com/18",
// 	environment: process.env.NODE_ENV
// });
// const userData = JSON.parse(localStorage.getItem('sentry-user'));
// if (userData !== null && userData.id !== undefined && userData.email !== undefined) {
// 	Sentry.setUser({'id': userData.id, 'email': userData.email});
// }

// Detects if device is on iOS 
const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return /iphone|ipad|ipod/.test(userAgent);
}
// Detects if device is in standalone mode
const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

if (process.env.NODE_ENV !== 'production') {
	const {whyDidYouUpdate} = require('why-did-you-update');
	whyDidYouUpdate(React, {
		include: [/^ConnectFunction/],
		groupByComponent: true,
		collapseComponentGroups: true,
	});
}

@connect((store) => {
	return {
		User: store.User,
		app: store.app,
		modal: store.modal,
		toasts: store.toasts,
		sessions: store.sessions,
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
		connected: store.connected
	}
})
class App extends Component {
	constructor(props) {
		super(props)
		this.handleMenuOpenClick = this.handleMenuOpenClick.bind(this)
		this.handleGoTo = this.handleGoTo.bind(this)
		this.logout = this.logout.bind(this)
		this.closeModal = this.closeModal.bind(this);
		this.messaging = this.messaging.bind(this);
		this.closeToast = this.closeToast.bind(this);
		this.redirect = this.redirect.bind(this);
		this.authListener = this.authListener.bind(this);
		this.fetchRedirectUrl = this.fetchRedirectUrl.bind(this);
		this.checkAuth = this.checkAuth.bind(this);
		this.blur = this.blur.bind(this)
		this.head = this.head.bind(this)
		this.state = {
			'blur': false,
			'show': false,
			'showInstallMessage': false,
			'enterFirstTime': 0
		}
		if ("Notification" in window) {
			this.messaging();
		}
		this.authListener()
		if (this.props.User.User.loggedIn) {
			this.props.dispatch(fetchTherapyCategories())
				.then(categories => {
					if (BUILDING) {
						// require all category images for build
						categories.forEach(cat => {
							if (cat.image) {
								require('./images/icons/categories/' + cat.image)
							}
						})
					}
				})
				.catch(e => {
					console.log(e)
				})
		}

	}

	shouldComponentUpdate(nextState) {
		return true;
	}

	/*
	static childContextTypes = {
		location: React.PropTypes.object
	}

	getChildContext() {
		return {location: this.props.location}
	}
	*/
	componentDidMount() {
		window.scroll(0, 1);
		// Checks if should display install popup notification:
		if (isIos() && !isInStandaloneMode()) {
			console.log('Is iOs and in standalone mode');
			this.setState({
				showInstallMessage: true
			});
		} else {
			console.log('Not iOs or in standalone mode');
		}

		if (NODE_ENV === 'production') {
			ReactGA.initialize('UA-133211082-1');
		} else {
			ReactGA.initialize('UA-000000-01');
		}
		ReactGA.pageview(window.location.pathname + window.location.search);
	}

	componentWillMount() {
		this.props.dispatch(listenToConnected())
		// this.props.dispatch(fetchPracticeTypes());
		if(this.props.User.admin){
			this.props.dispatch(fetchPractices())
		}
		// this.authListener = this.authListener.bind(this)
		this.props.dispatch(gettingToken(false));
		this.props.dispatch(setTitle('Specialt'));
	}

	componentWillUnmount() {
		// eslint-disable-next-line
		this.fireBaseListener && this.fireBaseListener();
		this.authListener = undefined;
	}

	componentDidUpdate(nextProps) {
		if (this.state.enterFirstTime === 0) {
			this.setState({
				enterFirstTime: 1
			});
		}

		if (this.props.User.User.name != nextProps.User.User.name) {
			this.checkAuth();
			this.props.dispatch(fetchPracticeTypes());
			if(this.props.User.admin){
				this.props.dispatch(fetchPractices())
			}
		}
	}

	checkAuth() {
		let { dispatch, User} = this.props;
		if (User.User.loggedIn && User.User.name !== '') {
			// Check if email has been verified.
			if(!User.User.email_verified && (User.User.email_communication === undefined || User.User.email_communication === null)) {
				// console.log('Verify Email');
				dispatch(setModal('UserEmailConfirm', null, {}, true, 'fullscreen'));
			} else {
				
				var fetchRedirectUrl = this.fetchRedirectUrl();
				// console.log('redirect url', fetchRedirectUrl);
				if (fetchRedirectUrl.redirectParam != '') {
					this.redirect(fetchRedirectUrl.redirectParam);
				} else if (fetchRedirectUrl.url_pathname == '/') {
					this.redirect('home');
				}
			}
		} else {
			console.log('Not Logged in.');
			var url_string = window.location.href;
			var url = new URL(url_string);
			// console.log('Pathname:', url.pathname);
			if (url.pathname !== '/') {
				var redirectUrl = '/?redirect=' + url.pathname;
				// console.log('Redirect 0:', redirectUrl);
				this.redirect(redirectUrl);
			}
		}
	}

	redirect(path) {
		// console.log('Redirect:', path);
		let { router } = this.props;
		return router.replace(path)
	}

	handleGoTo(path) {
		this.redirect(path);
	}

	closeModal() {
		this.props.dispatch(setModal())
	}

	closeToast(i) {
		const { dispatch } = this.props;
		dispatch(removeToast(i))
	}

	messaging() {
		const { dispatch, User, app } = this.props;

		const messaging = firebaseApp.messaging();
		messaging.requestPermission()
			.then(() => {
				return firebaseApp.messaging().getToken()
			})
			.then(token => {
				dispatch(setUser({ 'notificationToken': token }));
				if (app.authed) {
					dispatch(saveNotificationToken(User.User._id, token))
				} else {
					dispatch(setAppField('mustSendNotificationToken', true))
				}
			})
			.catch((err) => {
				console.log(err);
			})

		messaging.onMessage(payload => {

			if (payload.notification.title) {
				const toastIndex = this.props.toasts.length;
				dispatch(insertToast(payload.notification))
				this.toastTimeout = setTimeout(() => {
					dispatch(removeToast(toastIndex))
				}, 5000)
			}
		})
	}

	fetchRedirectUrl() {
		const { dispatch } = this.props;
		var url_string = window.location.href;
		var url = new URL(url_string);
		let redirectUrlData = {
			'route': this.props.route.path,
			'url_string': url_string,
			'url': url,
			'url_pathname': url.pathname,
			'redirectUrl': '',
			'redirectParam': '',
			'signedInUrl': ''
		}
		// console.log('Init Redirect URL Data:', redirectUrlData);
		if (redirectUrlData.url.searchParams.has('redirect')) {
			// console.log('Found Redirect:', redirectUrlData.url.searchParams.get('redirect'))
			redirectUrlData.redirectParam = redirectUrlData.url.searchParams.get('redirect');
			redirectUrlData.signedInUrl = (redirectUrlData.redirectParam.indexOf('/') === 0) ? redirectUrlData.redirectParam.replace('/', ''): redirectUrlData.redirectParam;
			dispatch(setUser({signedInUrl: redirectUrlData.signedInUrl}))
			redirectUrlData.redirectUrl = '?redirect='+redirectUrlData.redirectParam;
		} else {
			// console.log('Path:', redirectUrlData.route.path);
			// console.log('Url Path:', redirectUrlData.url.pathname);
			// console.log('Check Url Path:', (redirectUrlData.route.path !== redirectUrlData.url.pathname));
			if (redirectUrlData.route.path !== redirectUrlData.url.pathname) {
				redirectUrlData.redirectUrl = '?redirect='+ redirectUrlData.url.pathname;
				// console.log('Set Redirect:', redirectUrlData.redirectUrl)
			}
		}
		return redirectUrlData
	}

	authListener() {
		let redirectUrlData = this.fetchRedirectUrl();
		// console.log('Redirect Data 1:', redirectUrlData);
		this.fireBaseAuthListener = firebaseApp.auth().onAuthStateChanged((user) => {
			// console.log(user);
			if (user) {
				if (user != null) {
					let displayName = ''; let photoURL = '';
					user.providerData.forEach(function (profile) {
					  displayName = profile.displayName;
					  photoURL = profile.photoURL;
					});

					if (user.displayName !== displayName || user.photoURL !== photoURL) {
						console.log("  Name: " + displayName);
						console.log("  Photo URL: " + photoURL);
						user.updateProfile({
							displayName: displayName,
							photoURL: photoURL
						}).then(function() {
							// Update successful.
							console.log('update details successful')
						}).catch(function(error) {
							// An error happened.
							console.log('Error update details')
							console.log(error);
						});
					}
				}
				this.props.dispatch(getUserToken())
					.then((u) => {
						let unauthed = false;
						redirectUrlData = this.fetchRedirectUrl();
						// console.log('Redirect Data 2:', redirectUrlData);
						if (!this.props.route.publicRoute) {
							if (this.props.app.authed && !this.props.User.User._id) {
								return
							}
							unauthed = (this.props.route.adminRoute && !this.props.User.User.admin) ||
								(this.props.route.ownerRoute && !this.props.User.User.owner) ||
								(this.props.route.therapistRoute && !this.props.User.User.therapist);
							
							// console.log('Redirect 2:', redirectUrlData.redirectUrl);
							if (unauthed) {
								// console.log('Redirect 3:', redirectUrlData.redirectUrl);
								this.redirect('/' + redirectUrlData.redirectUrl);
							} else if (this.props.route.path === '/') {
								// console.log('Redirect 4:', redirectUrlData.redirectUrl);
								this.redirect('/home' + redirectUrlData.redirectUrl);
							}
						} else if (this.props.route.path === '/') { // if signin, send to home
							// console.log('Public Route:', this.props.route.publicRoute);
							// console.log('Redirect 5:', redirectUrlData.redirectUrl);
							this.redirect('/home' + redirectUrlData.redirectUrl);
						}

					}).catch((e) => {
						console.log("Could not authenticate with server", e)
						if (!this.props.route.publicRoute) {
							this.redirect('/' + redirectUrlData.redirectUrl);
						}

					});


			} else {
				// No user is signed in.
				this.props.dispatch({
					type: 'SET_AUTHED',
					payload: true
				})
				this.props.dispatch(removeUser());

				if (!this.props.route.publicRoute) {
					this.redirect('/' + redirectUrlData.redirectUrl);
				}
			}
		});
	}
	handleMenuOpenClick(evt) {
		this.refs.sideNav.openMenu()
	}

	logout() {

		firebaseApp.auth().signOut().then(() => {
			// Sign-out successful.
			this.props.dispatch({
				type: 'CLEAR_STATE'
			})
			console.log('loggin out....');
			localStorage.removeItem('sentry-user');
			this.props.dispatch(removeUser());
			this.redirect('/');
		}, function (error) {
			// An error happened.
			console.log(error)
		});
	}

	blur(val = false) {
		this.setState({
			blur: val
		})
	}

	head(val =false) {
		this.setState({
			show: val
		})
	}

	render() {
		const { User, app, modal, toasts } = this.props;
		const { blur } = this.state;

		if (User.User.loggedIn && User.User.name !== '') {
			// Check if terms conditions has been false or 
			// undefined then redirect to terms and conditions page.
			if (!this.props.User.User.terms_conditions) {
				if (!this.props.route.termsConditions) {
					var pathName = window.location.pathname;
					var redirectUrl = (pathName.indexOf("practice/")) ? '?redirect=' + pathName : '';
					var url = '/terms_conditions' + redirectUrl;
					// console.log('Redirect 6:', redirectUrl);
					this.redirect(url);
				}
			}
		}
		return (<div>
			{User.User.loggedIn &&
				<Sidenav ref="sideNav" callback={this.blur} User={User.User} Content={AppNav} onLogout={this.logout} dispatch={this.props.dispatch} />
				
			}
			<MediaUploadContent ref="MediaContentUpload"></MediaUploadContent>
			<div className={"App " + (User.User.loggedIn ? "fixed-menu " : "no-menu ") + (blur && " blur")}>
				{User.User.loggedIn && <Header title={app.title} onOpenMenuClick={this.handleMenuOpenClick} User={User.User}></Header>}
				<div className="app-content _jsHeadShow fill"
					style={
						{ overflowY: 'auto', width: '100%' }
					}>
					{/* {User.User.loggedIn && <Header title={app.title} onOpenMenuClick={this.handleMenuOpenClick} User={User.User}></Header>} */}
					{this.props.children}
				</div>

				{User.User.loggedIn && <MenuBar user={User.User} onLogout={this.logout} />}

				<Modal {...this.props} {...modal} close={this.closeModal} />
				<Toast toasts={toasts} closeToast={this.closeToast} />
				{!app.connected && <div className="connecting">Connecting ...</div>}
			</div>
			<SVGBlur />
		</div>)
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.jsx